import {
  ClinicTaskTypeModel,
  IClinicTaskTypeModel,
} from '@common/models/ClinicTaskTypeModel';
import { http } from '@common/utils';
import { trackPromise } from 'react-promise-tracker';
import { ServiceHelper } from '../serviceHelper';
import { ServiceMethodOptions } from '../types';

export class ClinicTaskTypeService {
  private static baseUrl: string = '/api/clinictasktype';

  static tags = {
    upsertClinicTaskType: 'upsertClinicTaskType',
    deleteClinicTaskType: 'deleteClinicTaskType',
  };

  static upsertClinicTaskType = (
    data: IClinicTaskTypeModel,
    options?: ServiceMethodOptions,
  ): Promise<ClinicTaskTypeModel> => {
    return trackPromise(
      new Promise<IClinicTaskTypeModel>((resolve, reject) => {
        http(`${this.baseUrl}`)
          .post<IClinicTaskTypeModel>(data)
          .then((response) => {
            ServiceHelper.showSuccess('Task Type updated.', options);
            resolve(new ClinicTaskTypeModel(response));
          })
          .catch((err) => {
            ServiceHelper.showError(
              `Failed to update Task Type. ${err}`,
              options,
            );
            reject(err);
          });
      }),
      this.tags.upsertClinicTaskType,
    );
  };

  static deleteClinicTaskType = (
    clinicTaskTypeId: number,
    options?: ServiceMethodOptions,
  ): Promise<boolean> => {
    return trackPromise(
      new Promise<boolean>((resolve, reject) => {
        http(`${this.baseUrl}/${clinicTaskTypeId}`)
          .delete()
          .then(() => {
            ServiceHelper.showSuccess('Task Type has been deleted.', options);
            resolve(true);
          })
          .catch((err) => {
            ServiceHelper.showError(
              `Failed to delete Task Type. ${err}`,
              options,
            );
            reject(err);
          });
      }),
      this.tags.deleteClinicTaskType,
    );
  };
}
